/**
 * Generated by orval v8.2.0 🍺
 * Do not edit manually.
 * Turaq kg
 * The Turaq kg API description
 * OpenAPI spec version: 0.1
 */
import { chatRequest } from '../mutator';
export type ChatErrorCode = typeof ChatErrorCode[keyof typeof ChatErrorCode];


export const ChatErrorCode = {
  CHAT_FORBIDDEN: 'CHAT_FORBIDDEN',
  CHAT_LISTING_NOT_FOUND: 'CHAT_LISTING_NOT_FOUND',
  CHAT_OWN_LISTING: 'CHAT_OWN_LISTING',
  CHAT_LISTING_UNAVAILABLE: 'CHAT_LISTING_UNAVAILABLE',
  CHAT_MESSAGE_TOO_LONG: 'CHAT_MESSAGE_TOO_LONG',
  CHAT_EMPTY_MESSAGE: 'CHAT_EMPTY_MESSAGE',
  CHAT_RATE_LIMITED: 'CHAT_RATE_LIMITED',
  CHAT_EDIT_WINDOW_EXPIRED: 'CHAT_EDIT_WINDOW_EXPIRED',
  CHAT_DELETE_WINDOW_EXPIRED: 'CHAT_DELETE_WINDOW_EXPIRED',
  CHAT_NOT_EDITABLE: 'CHAT_NOT_EDITABLE',
  CHAT_ATTACHMENT_INVALID: 'CHAT_ATTACHMENT_INVALID',
  CHAT_VALIDATION_FAILED: 'CHAT_VALIDATION_FAILED',
  CHAT_UNAUTHORIZED: 'CHAT_UNAUTHORIZED',
  CHAT_INTERNAL: 'CHAT_INTERNAL',
  CHAT_PIN_LIMIT: 'CHAT_PIN_LIMIT',
} as const;

export interface ChatErrorResponse {
  statusCode: number;
  timestamp: string;
  path: string;
  message: string;
  error: string;
  code: ChatErrorCode;
}

export interface CreateConversationDto {
  /** id объявления */
  listingId: number;
}

export type ChatListingStatus = typeof ChatListingStatus[keyof typeof ChatListingStatus];


export const ChatListingStatus = {
  active: 'active',
  sold: 'sold',
  reserved: 'reserved',
  archived: 'archived',
} as const;

export interface ListingSummaryResponse {
  id: number;
  title: string;
  /** Как `price` в API объявлений */
  price: string;
  /** @nullable */
  currency: string | null;
  /** @nullable */
  coverUrl: string | null;
  status: ChatListingStatus;
}

export interface CounterpartResponse {
  id: number;
  /** Пустая строка, если аккаунт удалён */
  name: string;
  /** @nullable */
  avatarUrl: string | null;
  isOnline: boolean;
  /** @nullable */
  lastSeenAt: string | null;
  /** Официальный аккаунт Turaq.kg */
  isOfficial: boolean;
  /** Проверенный продавец (галочка) */
  isVerified: boolean;
}

export type ChatMessageType = typeof ChatMessageType[keyof typeof ChatMessageType];


export const ChatMessageType = {
  text: 'text',
  image: 'image',
  system: 'system',
} as const;

export interface ReplyPreviewResponse {
  id: string;
  /** @nullable */
  senderId: number | null;
  type: ChatMessageType;
  /** @nullable */
  bodyPreview: string | null;
  /** @nullable */
  thumbUrl: string | null;
  deleted: boolean;
}

export interface AttachmentResponse {
  id: string;
  width: number;
  height: number;
  /** @nullable */
  blurhash: string | null;
  size: number;
  /**
   * Signed GET
   * @nullable
   */
  thumbUrl: string | null;
  /**
   * Signed GET
   * @nullable
   */
  displayUrl: string | null;
}

export interface ReactionSummaryResponse {
  emoji: string;
  count: number;
  /** Есть ли среди них моя реакция */
  mine: boolean;
}

export interface MessageResponse {
  id: string;
  conversationId: string;
  /** bigint строкой: десятичное неотрицательное целое без ведущих нулей */
  seq: string;
  /** @nullable */
  senderId: number | null;
  type: ChatMessageType;
  /** @nullable */
  body: string | null;
  /** @nullable */
  replyTo: ReplyPreviewResponse | null;
  attachments: AttachmentResponse[];
  /** @nullable */
  clientMsgId: string | null;
  createdAt: string;
  /** @nullable */
  editedAt: string | null;
  /** @nullable */
  deletedAt: string | null;
  reactions: ReactionSummaryResponse[];
}

export type ChatConversationKind = typeof ChatConversationKind[keyof typeof ChatConversationKind];


export const ChatConversationKind = {
  direct: 'direct',
  channel: 'channel',
} as const;

export interface ConversationResponse {
  id: string;
  /**
   * null — объявление удалено
   * @nullable
   */
  listing: ListingSummaryResponse | null;
  counterpart: CounterpartResponse;
  /** @nullable */
  lastMessage: MessageResponse | null;
  unreadCount: number;
  updatedAt: string;
  /** bigint строкой: десятичное неотрицательное целое без ведущих нулей */
  myLastReadSeq: string;
  /** bigint строкой: десятичное неотрицательное целое без ведущих нулей */
  counterpartLastDeliveredSeq: string;
  /** bigint строкой: десятичное неотрицательное целое без ведущих нулей */
  counterpartLastReadSeq: string;
  kind: ChatConversationKind;
  /** @nullable */
  pinnedAt: string | null;
  /** @nullable */
  archivedAt: string | null;
  /**
   * Сообщения до этого seq удалены у меня; null — не удаляли
   * @nullable
   */
  clearedUpToSeq: string | null;
}

export interface ConversationListResponse {
  items: ConversationResponse[];
  /** @nullable */
  nextCursor: string | null;
}

export interface SetPinnedDto {
  pinned: boolean;
}

export interface ConversationPrefsResponse {
  conversationId: string;
  /** @nullable */
  pinnedAt: string | null;
  /** @nullable */
  archivedAt: string | null;
  /** @nullable */
  clearedUpToSeq: string | null;
}

export interface SetArchivedDto {
  archived: boolean;
}

export interface ClearConversationDto {
  /** Скрыть сообщения до этого seq включительно (обрезается до last_seq). Без него — все текущие. */
  upToSeq?: string;
}

export interface MessageListResponse {
  items: MessageResponse[];
  hasMore: boolean;
}

export interface UnreadCountResponse {
  total: number;
}

export interface SetReactionDto {
  /** Одна из ALLOWED_REACTIONS (chat.events.ts: QUICK_REACTIONS + MORE_REACTIONS) */
  emoji: string;
}

export interface ReactionsResponse {
  reactions: ReactionSummaryResponse[];
}

export type PresignFileDtoMime = typeof PresignFileDtoMime[keyof typeof PresignFileDtoMime];


export const PresignFileDtoMime = {
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
  'image/webp': 'image/webp',
} as const;

export interface PresignFileDto {
  /** Только для клиента; в ключах хранилища не используется */
  name: string;
  mime: PresignFileDtoMime;
  /** Байты */
  size: number;
}

export interface PresignRequestDto {
  conversationId: string;
  files: PresignFileDto[];
}

export type PresignItemResponseMethod = typeof PresignItemResponseMethod[keyof typeof PresignItemResponseMethod];


export const PresignItemResponseMethod = {
  PUT: 'PUT',
} as const;

/**
 * Отправить PUT ровно с этими заголовками
 */
export type PresignItemResponseHeaders = {[key: string]: string};

export interface PresignItemResponse {
  attachmentId: string;
  /** Presigned PUT, действует CHAT_PRESIGN_TTL_SECONDS */
  uploadUrl: string;
  method: PresignItemResponseMethod;
  /** Отправить PUT ровно с этими заголовками */
  headers: PresignItemResponseHeaders;
}

export interface PresignResponse {
  items: PresignItemResponse[];
}

export interface AttachmentUrlsResponse {
  thumbUrl: string;
  displayUrl: string;
  expiresAt: string;
}

export type ConversationsControllerListParams = {
/**
 * Непрозрачный курсор из nextCursor
 */
cursor?: string;
/**
 * @maximum 50
 */
limit?: number;
filter?: ConversationsControllerListFilter;
};

export type ConversationsControllerListFilter = typeof ConversationsControllerListFilter[keyof typeof ConversationsControllerListFilter];


export const ConversationsControllerListFilter = {
  all: 'all',
  unread: 'unread',
} as const;

export type MessagesControllerBeforeParams = {
/**
 * Вернуть сообщения с seq < beforeSeq; без него — последние
 */
beforeSeq?: string;
/**
 * @maximum 30
 */
limit?: number;
};

export type MessagesControllerAfterParams = {
/**
 * Вернуть сообщения с seq > afterSeq
 */
afterSeq: string;
/**
 * @maximum 100
 */
limit?: number;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Текущий пользователь — покупатель, продавец — владелец объявления. Новый диалог: объявление active/reserved и одобрено модерацией. Существующий диалог возвращается при любом статусе.
 * @summary Get-or-create диалога по объявлению
 */
export const conversationsControllerCreate = (
    createConversationDto: CreateConversationDto,
 options?: SecondParameter<typeof chatRequest<ConversationResponse>>,) => {
      return chatRequest<ConversationResponse>(
      {url: `/api/chat/conversations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createConversationDto
    },
      options);
    }
  
/**
 * Сортировка updatedAt DESC, id DESC; keyset-курсор.
 * @summary Список диалогов
 */
export const conversationsControllerList = (
    params?: ConversationsControllerListParams,
 options?: SecondParameter<typeof chatRequest<ConversationListResponse>>,) => {
      return chatRequest<ConversationListResponse>(
      {url: `/api/chat/conversations`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Один диалог (deep link)
 */
export const conversationsControllerGetOne = (
    id: string,
 options?: SecondParameter<typeof chatRequest<ConversationResponse>>,) => {
      return chatRequest<ConversationResponse>(
      {url: `/api/chat/conversations/${id}`, method: 'GET'
    },
      options);
    }
  
/**
 * Сообщения до upToSeq (≤ last_seq) больше не отдаются мне; диалог скрыт в списке до нового сообщения; закрепление и архив снимаются. Собеседник ничего не замечает.
 * @summary Удалить чат у себя
 */
export const conversationsControllerRemove = (
    id: string,
    clearConversationDto: ClearConversationDto,
 options?: SecondParameter<typeof chatRequest<ConversationPrefsResponse>>,) => {
      return chatRequest<ConversationPrefsResponse>(
      {url: `/api/chat/conversations/${id}`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: clearConversationDto
    },
      options);
    }
  
/**
 * Не больше 3 закреплённых (409 CHAT_PIN_LIMIT). Закрепление снимает архив. Остальные устройства получают conversation:prefs.
 * @summary Закрепить / открепить диалог (у себя)
 */
export const conversationsControllerPin = (
    id: string,
    setPinnedDto: SetPinnedDto,
 options?: SecondParameter<typeof chatRequest<ConversationPrefsResponse>>,) => {
      return chatRequest<ConversationPrefsResponse>(
      {url: `/api/chat/conversations/${id}/pin`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setPinnedDto
    },
      options);
    }
  
/**
 * Архив снимает закрепление.
 * @summary Архивировать / вернуть из архива (у себя)
 */
export const conversationsControllerArchive = (
    id: string,
    setArchivedDto: SetArchivedDto,
 options?: SecondParameter<typeof chatRequest<ConversationPrefsResponse>>,) => {
      return chatRequest<ConversationPrefsResponse>(
      {url: `/api/chat/conversations/${id}/archive`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setArchivedDto
    },
      options);
    }
  
/**
 * seq < beforeSeq (без него — последние), items по seq DESC.
 * @summary История назад
 */
export const messagesControllerBefore = (
    id: string,
    params?: MessagesControllerBeforeParams,
 options?: SecondParameter<typeof chatRequest<MessageListResponse>>,) => {
      return chatRequest<MessageListResponse>(
      {url: `/api/chat/conversations/${id}/messages`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * seq > afterSeq, items по seq ASC. При hasMore — повторить с seq последнего.
 * @summary Догрузка вперёд (reconnect)
 */
export const messagesControllerAfter = (
    id: string,
    params: MessagesControllerAfterParams,
 options?: SecondParameter<typeof chatRequest<MessageListResponse>>,) => {
      return chatRequest<MessageListResponse>(
      {url: `/api/chat/conversations/${id}/messages/after`, method: 'GET',
        params
    },
      options);
    }
  
/**
 * @summary Всего непрочитанных (CONTRACT §4)
 */
export const messagesControllerUnreadCount = (
    
 options?: SecondParameter<typeof chatRequest<UnreadCountResponse>>,) => {
      return chatRequest<UnreadCountResponse>(
      {url: `/api/chat/unread-count`, method: 'GET'
    },
      options);
    }
  
/**
 * Одна реакция от человека. Нельзя на удалённые и системные (409 CHAT_NOT_EDITABLE), не участнику или при блокировке (403). Собеседник получает message:reactions.
 * @summary Поставить / заменить мою реакцию
 */
export const messagesControllerReact = (
    id: string,
    setReactionDto: SetReactionDto,
 options?: SecondParameter<typeof chatRequest<ReactionsResponse>>,) => {
      return chatRequest<ReactionsResponse>(
      {url: `/api/chat/messages/${id}/reaction`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setReactionDto
    },
      options);
    }
  
/**
 * @summary Убрать мою реакцию
 */
export const messagesControllerUnreact = (
    id: string,
 options?: SecondParameter<typeof chatRequest<ReactionsResponse>>,) => {
      return chatRequest<ReactionsResponse>(
      {url: `/api/chat/messages/${id}/reaction`, method: 'DELETE'
    },
      options);
    }
  
/**
 * 1..CHAT_MAX_ATTACHMENTS файлов, image/jpeg|png|webp, ≤ CHAT_MAX_ATTACHMENT_SIZE_MB. items в порядке files. PUT — ровно с заголовками из headers.
 * @summary Presigned PUT для фото
 */
export const uploadsControllerPresign = (
    presignRequestDto: PresignRequestDto,
 options?: SecondParameter<typeof chatRequest<PresignResponse>>,) => {
      return chatRequest<PresignResponse>(
      {url: `/api/chat/uploads/presign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: presignRequestDto
    },
      options);
    }
  
/**
 * Идемпотентно: для ready возвращает тот же результат.
 * @summary Завершить загрузку: проверка и обработка изображения
 */
export const uploadsControllerComplete = (
    attachmentId: string,
 options?: SecondParameter<typeof chatRequest<AttachmentResponse>>,) => {
      return chatRequest<AttachmentResponse>(
      {url: `/api/chat/uploads/${attachmentId}/complete`, method: 'POST'
    },
      options);
    }
  
/**
 * @summary Обновить истёкшие signed URL
 */
export const uploadsControllerUrls = (
    id: string,
 options?: SecondParameter<typeof chatRequest<AttachmentUrlsResponse>>,) => {
      return chatRequest<AttachmentUrlsResponse>(
      {url: `/api/chat/attachments/${id}/urls`, method: 'GET'
    },
      options);
    }
  
export type ConversationsControllerCreateResult = NonNullable<Awaited<ReturnType<typeof conversationsControllerCreate>>>
export type ConversationsControllerListResult = NonNullable<Awaited<ReturnType<typeof conversationsControllerList>>>
export type ConversationsControllerGetOneResult = NonNullable<Awaited<ReturnType<typeof conversationsControllerGetOne>>>
export type ConversationsControllerRemoveResult = NonNullable<Awaited<ReturnType<typeof conversationsControllerRemove>>>
export type ConversationsControllerPinResult = NonNullable<Awaited<ReturnType<typeof conversationsControllerPin>>>
export type ConversationsControllerArchiveResult = NonNullable<Awaited<ReturnType<typeof conversationsControllerArchive>>>
export type MessagesControllerBeforeResult = NonNullable<Awaited<ReturnType<typeof messagesControllerBefore>>>
export type MessagesControllerAfterResult = NonNullable<Awaited<ReturnType<typeof messagesControllerAfter>>>
export type MessagesControllerUnreadCountResult = NonNullable<Awaited<ReturnType<typeof messagesControllerUnreadCount>>>
export type MessagesControllerReactResult = NonNullable<Awaited<ReturnType<typeof messagesControllerReact>>>
export type MessagesControllerUnreactResult = NonNullable<Awaited<ReturnType<typeof messagesControllerUnreact>>>
export type UploadsControllerPresignResult = NonNullable<Awaited<ReturnType<typeof uploadsControllerPresign>>>
export type UploadsControllerCompleteResult = NonNullable<Awaited<ReturnType<typeof uploadsControllerComplete>>>
export type UploadsControllerUrlsResult = NonNullable<Awaited<ReturnType<typeof uploadsControllerUrls>>>
